import React, { useEffect, useRef, useState } from 'react';
import Sidenav from './sidebar';
import { faArrowLeft, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Dropdown,
    makeStyles,
    Option,
    shorthands,
    Avatar,
    Menu,
    MenuTrigger,
    MenuList,
    MenuItem,
    MenuPopover,

} from "@fluentui/react-components";
import PhoneInput from 'react-phone-input-2';
import { DeleteAction } from '../dialogues/dialogue-delete';
import ToastrService from '../toaster/ToastrService';
import { Checked } from './checkbox';
import { CustomOptionsDropdown } from './dropdown';
import { Dateformat, Timeformat, WeekDropdown } from './my-settings';
import { CustomTimePicker } from './timePicker';
import { WorkViewDropdown } from './workViewDropdown';
import { getSettings } from '../../viewmodel/getsettings';
import { CommonInfo } from '../../CommonData/Config';
import { Image } from "@fluentui/react-components";
import { useLocation, useNavigate } from 'react-router-dom';
import { DatePicker, DatePickerProps, Flex } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import './teams_workplaces.css'
import GetSettingsService from '../../APIService/mySettingsService';
import { useParams } from 'react-router-dom'
import LoginService from '../../APIService/loginservice';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

const Commondata = CommonInfo;
const getSettingsData = getSettings;

interface WorkplaceException {
    Date: string;
    StartDateTime: string;
    EndDateTime: string;
    WorkingPlace: string;
    Id: any | null;
    Action: string;
}

type WorkLocation = {
    StartTime: string;
    EndTime: string;
    Place: string;
    Date?: string;
    WorkplaceException?: boolean;
};

type WorkLocations = {
    [day: string]: WorkLocation[];
};

interface Workplace {
    StartTime: string; EndTime: string; Place: string
}

const TeamWorkPlaces: React.FC = () => {
    const {t} = useTranslation();
    const [isCalendarVisible, setCalendarVisible] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | null>(moment().toDate());
    const [selectedDatePicker, setSelectedDatePicker] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const navigate = useNavigate();
    const [checkedDays, setCheckedDays] = useState(Array(7).fill(true));
    const [filteredResults, setFilteredResults] = useState<any[]>([]);
    const WeekDays: any[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    const rearrangeWeekDays = (firstDay: string): string[] => {
        const index = WeekDays.indexOf(firstDay);
        if (index === -1) return WeekDays; // Return original array if the first day is not found
        return [...WeekDays.slice(index), ...WeekDays.slice(0, index)];
    };
    const firstDayOfWeek = localStorage.getItem('Firstdayofweek') || 'Monday';
    const rearrangedWeekDays = rearrangeWeekDays(firstDayOfWeek);
    const [workLocations, setWorkLocations] = useState<{ [key: string]: { StartTime: string; EndTime: string; Place: string }[] }>(
        rearrangedWeekDays.reduce((acc, day) => ({ ...acc, [day]: [] }), {})
    );
    const [locations, setLocations] = useState<{ [key: string]: { StartTime: string; EndTime: string; Place: string }[] }>(
        rearrangedWeekDays.reduce((acc, day) => ({ ...acc, [day]: [] }), {})
    );
    const [workplaces, setWorkplaces] = useState<Record<string, Workplace[]>>({}); const [hoveredCard, setHoveredCard] = useState(null);
    const dayMapping: { [key: string]: string } = {
        'Sun': 'Sunday',
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday'
    };
    const is24HrFormat = getSettingsData.data && getSettingsData.data['Is24HrFormat'];
    const userIdString = localStorage.getItem('userId'); // userIdString is of type string | null
    let userId: any;
    if (userIdString !== null) {
        userId = parseInt(userIdString); // Parse the value as an integer
    } else {
    }
    const userEmail = localStorage.getItem('userEmail')
    let { id } = useParams();
    let { department } = useParams();
    const [Currentweek, SetCurrentWeek] = useState<string[]>([])
    const [workplaceexceptions, setWorkplaceexceptions] = useState<WorkplaceException[]>([]);


    useEffect(() => {
        if (localStorage.getItem('Theme') === 'dark') {
            document.body.classList.add('dark-theme');

        }
        getMySettings();
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])
    let startDate: any;

    useEffect(() => {


        initializeSelectedDate();
    }, []);

    const initializeSelectedDate = () => {
        const firstDayOfWeekString = getSettingsData.data.FirstDayOfWeek || localStorage.getItem('Firstdayofweek') || 'Sunday';
        const today = moment();
        let startOfWeek = today.clone().startOf('week').day(firstDayOfWeekString);

        // Adjust if the startOfWeek is after today, meaning we are in a new week
        if (startOfWeek.isAfter(today)) {
            startOfWeek.subtract(1, 'week');
        }
        startDate = getCurrentWeekDates(startOfWeek);
        setSelectedDate(startDate);

    };

    const getCurrentWeekDates = (startOfWeek: moment.Moment,) => {
        const today = moment().startOf('day'); // Get today's date without time for comparison
        const weekDates = [];
        const workingDaysString = localStorage.getItem('Workingdays');
        const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};;
        let firstValidDay: moment.Moment | null = null;
        for (let i = 0; i < 7; i++) {
            const date = startOfWeek.clone().add(i, 'days');
            const dayName = date.format('dddd');

            if (workingDays[dayName]) {
                if (!firstValidDay) {
                    firstValidDay = date.clone();
                }
                weekDates.push(date.toDate());
            }
        }
        console.log("weekDates", weekDates);
        const isAnyDateInWeekValid = weekDates.some(date => moment(date).isSameOrAfter(today));
        if (firstValidDay && isAnyDateInWeekValid) {
            console.log("Starting date of the current week:", firstValidDay.toDate());
            return firstValidDay.toDate();
        } else {
            let nextWeekStart = startOfWeek.clone().add(1, 'week');
            for (let i = 0; i < 7; i++) {
                const date = nextWeekStart.clone().add(i, 'days');
                const dayName = date.format('dddd');

                if (workingDays[dayName]) {
                    console.log("Next valid working day:", date.toDate());
                    return date.toDate();
                }
            }
        }

        return today.toDate();
    };


    const getMySettings = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                localStorage.setItem('Firstdayofweek', getDataResult.data.d.FirstDayOfWeek);
                getSettingsData.data = getDataResult.data.d
                SetWorkingDays(getDataResult.data.d.WorkingDays)
                getSettingsData.data.Departments = getDataResult.data.d.Departments;
                await GetMySettingsBasic();
                await GetWorkPlacesList();

            }
        } catch (error) {
        }
    };


    const GetMySettingsBasic = async () => {
        try {
            const getResult = await GetSettingsService.GetSettingsBasic(userId, userEmail)
            if (getResult.data.d) {
                getSettingsData.MysettingsBasicdata = getResult.data.d;
                await GetWorklocation()
            }
        } catch (error) {

        }
    }

    const GetWorklocation = async () => {
        const dateRange = getWeekDates();
        try {
            let data = {
                Id: userId,
                EmailAddress: userEmail,
                Date: moment(startDate).format('DD/MM/YYYY'),
                StartDateTime: moment(dateRange.startDate, 'YYYY-MM-DD ').format('DD/MM/YYYY HH:mm'),
                EndDateTime: moment(dateRange.endDate, 'YYYY-MM-DD').add(1, 'day').format('DD/MM/YYYY HH:mm'),

            }
            const getResult = await GetSettingsService.GetWorkLocation(data);
            if (getResult.data.d) {
                getSettingsData.GetWorkLocationdata = getResult.data.d;
                await GetMyTeamWorkPlaces();

            }
        } catch (error) {

        }
    }

    const GetMyTeamWorkPlaces = async () => {
        const dateRange = getWeekDates();
        try {
            const data = {
                Id: id,
                DateStart: moment(dateRange.startDate, 'YYYY-MM-DD ').format('DD/MM/YYYY'),
                DateEnd: moment(dateRange.endDate, 'YYYY-MM-DD ').add(1, 'day').format('DD/MM/YYYY')
            }
            const getResult = await GetSettingsService.GetTeamWorkPlaces(data)
            if (getResult.data.d) {
                // getSettingsData.GetTeamsWorkplace.TeamMembers = sortedMembers;
                getSettingsData.GetTeamsWorkplace = getResult.data.d;

                console.log("getSettingsData.GetTeamsWorkplace.TeamMembers", getSettingsData.GetTeamsWorkplace.TeamMembers);

                getArray('Before');
            }
        }
        catch (error) {

        }
    }

    function getWeekDates() {

        const storedValue = localStorage.getItem('Firstdayofweek');
               const firstDayOfWeekStr = storedValue === "null" ? 'Monday' : storedValue; // Default to 'Monday'
       
               // Map string day names to numbers (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
               const dayMap: { [key: string]: number } = {
                   'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
                   'Thursday': 4, 'Friday': 5, 'Saturday': 6
               };
       
               const firstDayOfWeek = dayMap[firstDayOfWeekStr ?  firstDayOfWeekStr : "Monday"] ?? 1; // Default to Monday (1) if invalid
       
               // Convert startDate to a moment object
               const selectedMoment = moment(startDate, 'YYYY-MM-DD').startOf('day');
       
               // Find the start of the week based on the selected first day
               let startOfWeek = selectedMoment.clone().day(firstDayOfWeek);
       
               // If selected date is before the computed startOfWeek, move back a week
               if (selectedMoment.isBefore(startOfWeek)) {
                   startOfWeek.subtract(7, 'days');
               }
       
               // Generate week dates
               const weekDates: string[] = [];
               for (let i = 0; i < 7; i++) {
                   weekDates.push(startOfWeek.clone().add(i, 'days').format('YYYY-MM-DD'));
               }
       
               console.log("weekDates", weekDates);
       
               SetCurrentWeek(weekDates); // Update your state
       
               return {
                   startDate: weekDates[0],
                   endDate: weekDates[6],
                   CurrentWeek: weekDates.map(date => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY'))
               };
    }

    const logOut = async () => {
        Swal.fire({
            title: t('LogoutConfirmation'),
            text: t('AreYouSureYouWantToLogout?'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
            cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
            customClass: {
                popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
            },
            confirmButtonText: "Yes"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const LogOut = await LoginService.logout();
                if (LogOut.data.ErrCode === '') {
                    localStorage.setItem('loggedIn', 'false');
                    navigate('/login');
                }
            }
        });

    }

    const goBack = () => {
        navigate('/workplace');
    }

    const handleIconClick = () => {
        setCalendarVisible(!isCalendarVisible);
        if (localStorage.getItem('Theme') === 'dark') {
            document.querySelectorAll('.ant-picker-panel-container').forEach((element) => {
                element.classList.add('Dark_calender');
            });
        }
    };

    const datePickerRef = useRef<HTMLDivElement>(null);
    const iconRef = useRef<HTMLSpanElement>(null);
    const handleClickOutside = (event: MouseEvent) => {
        // Ensure refs are not null and check if the click was outside
        if (
            datePickerRef.current &&
            !datePickerRef.current.contains(event.target as Node) &&
            iconRef.current &&
            !iconRef.current.contains(event.target as Node)
        ) {
            setCalendarVisible(false);
        }
    };

    const setRightLeftDate = async (type: 'left' | 'right') => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays;
        setCalendarVisible(false);
        let givenDate = selectedDate ? new Date(selectedDate) : null;
        let oneDayLaterOrEarlier: any = givenDate ? new Date(givenDate) : null;

        if (type === 'left') {
            oneDayLaterOrEarlier = getNextEnabledDate(oneDayLaterOrEarlier, -7, workingDays);
        } else {
            oneDayLaterOrEarlier = getNextEnabledDate(oneDayLaterOrEarlier, 7, workingDays);
        }
        oneDayLaterOrEarlier?.setHours(0);
        oneDayLaterOrEarlier?.setMinutes(0);
        oneDayLaterOrEarlier?.setSeconds(0);
        oneDayLaterOrEarlier?.setMilliseconds(0);
        startDate = oneDayLaterOrEarlier
        setSelectedDate(oneDayLaterOrEarlier);
        setSelectedDatePicker(moment(oneDayLaterOrEarlier).format('YYYY-MM-DD'));
        await GetMySettingsBasic();
    };

    const getNextEnabledDate = (date: any, increment: any, WorkingDays: any) => {
        let nextDate = new Date(date);
        const enabledDays = Object.values(WorkingDays).some(day => day !== false);

        if (!enabledDays) {
            // Handle the case where all working days are false
            ToastrService.warning(t('PleaseConfigureDefaultWorkplaces'));
        }
        else {
            while (true) {
                nextDate.setDate(nextDate.getDate() + increment);
                const dayOfWeek = nextDate.toLocaleDateString('en-US', { weekday: 'long' });
                if (WorkingDays[dayOfWeek] !== false) {
                    return nextDate;
                }
            }
        }


    };

    const setTodayDate = async () => {
        const today = moment().startOf('day').toDate();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        // Set the new selected date
        setSelectedDate(today);
        startDate = today;
        setSelectedDatePicker(moment(today).format('YYYY-MM-DD'));
        showCurrentweek(true);
        // Call getDateWithOriginal to update dates for the new week
        await getMySettings();
    };


    const [currentweek, showCurrentweek] = useState(false);
    const handleDateSelect: DatePickerProps['onChange'] = async (date: any, dateString: any) => {
        const selectedDate = moment(date.$d).startOf('day');
        setSelectedDate(selectedDate.toDate())
        startDate = selectedDate.toDate()
        setSelectedDatePicker(selectedDate.format('YYYY-MM-DD'));
        setCalendarVisible(false);
        showCurrentweek(true);
        await getMySettings();
    };

    const convertToTimeString = (timeString: string) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}`;
    };

    let initialWorkLocations: any;
    initialWorkLocations = getSettingsData.data?.DefaultWorkPlaces ? getSettingsData.data?.DefaultWorkPlaces : [];
    for (const day in initialWorkLocations) {
        if (initialWorkLocations.hasOwnProperty(day)) {
            const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                ...item,
                StartTime: convertToTimeString(item.StartTime),
                EndTime: convertToTimeString(item.EndTime)
            }));
            initialWorkLocations[day] = updatedTimes;
        }
    }

    const GetWorkPlacesList = async () => {
        try {
            const data =
            {
                "UserId": userId,
                "EmailAddress": userEmail,
                "LocationId": getSettingsData.data.DefaultLocation?.LocationId ? getSettingsData.data.DefaultLocation?.LocationId : null

            }
            // {
            //     "UserId": 1003,
            //     "EmailAddress": "vijay.manickam@qedas.com",
            //     "LocationId": 98
            // }

            const getResult = await GetSettingsService.GetWorkPlacesList(data);
            if (getResult.data.d) {
                getSettingsData.workPlacelist = getResult.data.d.WorkPlaces;
                if (getSettingsData.workPlacelist.length <= 0) {
                    getSettingsData.workPlacelist = [
                        {
                            Id: 0,
                            Name: t('NoDataAvailable'),
                            IconPath: "",
                            LocationId: 0
                        }
                    ]

                }

            }
        } catch (error) {

        }
    }
    const getArray = async (type: 'Before' | 'After') => {
        const workingDays = type === 'Before' ? getSettingsData.data?.WorkingDays : WorkingDays;
        const teamMembers = getSettingsData.GetTeamsWorkplace.TeamMembers;

        teamMembers.sort((a: any, b: any) => {
            // Sort by Role: Team Leader comes first
            if (a.Role === "Team Leader" && b.Role === "Member") {
                return -1;
            } else if (a.Role === "Member" && b.Role === "Team Leader") {
                return 1;
            } else {
                // If roles are the same, sort alphabetically by name
                return a.Name.trim().localeCompare(b.Name.trim());
            }
        });

        const index = teamMembers.findIndex((member: any) => member.Id === userId);
        if (index !== -1) {
            const [removed] = teamMembers.splice(index, 1);
            teamMembers.unshift(removed);
        }
        let initialWorkLocations: any;
        getSettingsData.GetTeamsWorkplace.TeamMembers.forEach((member: any) => {
            if (member.Id === userId) {
                initialWorkLocations = member.DefaultWorkPlaces

            }

        });

        Object.keys(initialWorkLocations).forEach((day) => {
            const schedules = initialWorkLocations[day];
            if (schedules.length > 0) {
                const schedule = schedules[0];
                getSettingsData.GetTeamsWorkplace.TeamMembers.forEach((teamMembers: any) => {
                    teamMembers.DefaultWorkPlaces[day].forEach((v: any) => {
                        v.StartTime = formatDateToTimeString(moment(v.StartTime, 'HH:mm').toDate());
                        v.EndTime = formatDateToTimeString(moment(v.EndTime, 'HH:mm').toDate());
                        v.WorkplaceException = getSettingsData.GetWorkLocationdata.WorkPlaceExceptions == null ? true : false;
                        v.Id = 0;

                    });
                })

            }
        });
        const weekDates: any = getWeekDates().CurrentWeek;
        // Find any matching exceptions for the current week
        const exceptions = getSettingsData.GetWorkLocationdata.WorkPlaceExceptions?.filter((exception: any) => {
            return exception.Date && weekDates.includes(exception.Date);
        }) || [];

        console.log('exceptions', exceptions);
        const groupedExceptions = exceptions.reduce((acc: any, exception: any) => {
            const date = exception.Date;
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(exception);
            return acc;
        }, {});

        console.log(groupedExceptions);
        const exceptionsArray = Object.keys(groupedExceptions).reduce((acc, date) => {
            return acc.concat(groupedExceptions[date]);
        }, []);
        console.log("exceptionsArray", exceptionsArray);

        let updatedWorkLocations = { ...initialWorkLocations };
        Object.keys(groupedExceptions).forEach(date => {
            console.log(`Date: ${date}`);

            if (groupedExceptions[date].length > 0) {
                groupedExceptions[date].forEach((exception: any) => {
                    const momentDate = moment(date, 'DD/MM/YYYY');
                    if (momentDate.isValid()) {
                        const day = momentDate.format('dddd');
                        const startTime = getSettingsData.data.Is24HrFormat
                            ? moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('h:mm A');
                        const endTime = getSettingsData.data.Is24HrFormat
                            ? moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('h:mm A');
                        const newLocation = {
                            StartTime: startTime,
                            EndTime: endTime,
                            Place: exception.WorkingPlace,
                            WorkplaceException: true,
                            Id: exception.Id

                        };

                        // Overwrite the day's work locations with the exception
                        updatedWorkLocations[day] = updatedWorkLocations[day] || []; // Ensure array exists
                        updatedWorkLocations[day].push(newLocation);
                    } else {
                        console.error('Invalid date format in exception:', exception.Date);
                    }
                });
            } else {
                updatedWorkLocations = { ...initialWorkLocations }
            }
        });



        const orderedDays = Object.values(dayMapping);

        if (!getSettingsData.data.WorkingDays) {
            setCheckedDays(Object.values(false))
        }
        orderedDays.forEach((day, index) => {
            if (day !== Object.keys(workingDays)[index]) {
                let temp = workingDays[day];
                delete workingDays[day];
                workingDays[day] = temp;
            }
        });
        setCheckedDays(Object.values(workingDays));
        const filteredDefaultWorkPlaces = Object.keys(updatedWorkLocations).reduce((acc: any, day: any) => {
            if (workingDays[day]) {
                acc[day] = initialWorkLocations[day];
            } else {
                acc[day] = [];
            }
            return acc;
        }, {});
        Object.keys(workingDays).forEach(day => {
            if (workingDays[day] && (!filteredDefaultWorkPlaces[day] || filteredDefaultWorkPlaces[day].length === 0)) {
                filteredDefaultWorkPlaces[day] = [{ StartTime: "", EndTime: "", Place: "" }];  // Set an empty array for days with true but no data
            }
        });

        const Workplaces: any = {};

        Object.keys(filteredDefaultWorkPlaces).forEach(day => {
            const entries = filteredDefaultWorkPlaces[day];
            const hasTrueException = entries.some((entry: any) => entry.WorkplaceException);
            if (hasTrueException) {
                Workplaces[day] = entries.filter((entry: any) => entry.WorkplaceException).sort(compareTimes);
            } else {
                Workplaces[day] = entries.sort(compareTimes);
            }
        });
        getSettingsData.GetTeamsWorkplace.TeamMembers.forEach((member: any) => {
            if (member.Id !== userId) {
                // Iterate through each day in DefaultWorkPlaces
                Object.keys(member.DefaultWorkPlaces).forEach((day) => {
                    const defaultSchedules = member.DefaultWorkPlaces[day]; // Default schedules for this day

                    if (defaultSchedules && defaultSchedules.length > 0) {
                        // Filter exceptions that match the weekDates
                        const exceptions = member.WorkPlaceException?.filter((exception: any) => {
                            return exception.Date && weekDates.includes(exception.Date);
                        }) || [];

                        // Check if there are exceptions for this day
                        const exceptionsForDay = exceptions.filter((exception: any) => {
                            const exceptionDate = moment(exception.Date, 'DD/MM/YYYY');
                            return exceptionDate.isValid() && exceptionDate.format('dddd') === day;
                        });

                        if (exceptionsForDay.length > 0) {
                            // Update the specific day's schedules with exceptions
                            member.DefaultWorkPlaces[day] = exceptionsForDay.map((exception: any) => ({
                                StartTime: formatDateToTimeString(moment(exception.StartTime, 'HH:mm').toDate()),
                                EndTime: formatDateToTimeString(moment(exception.EndTime, 'HH:mm').toDate()),
                                Place: exception.Place,
                                WorkplaceException: true,
                                Id: exception.Id,
                            }));
                        } else {
                            // Keep the default schedules for this day if no exceptions
                            member.DefaultWorkPlaces[day] = defaultSchedules.map((schedule: any) => ({
                                ...schedule,
                                WorkplaceException: false,
                            }));
                        }
                    }
                });
            }
        });


        setWorkplaces(updatedWorkLocations);
        setWorkLocations(Workplaces);
        setLocations(Workplaces)
        setWorkplaceexceptions(getSettingsData.GetWorkLocationdata.WorkPlaceExceptions);
    };

    const compareTimes = (a: any, b: any) => {
        const parseTime = (timeStr: any) => {
            const [time, modifier] = timeStr.split(' ');
            let [hours, minutes] = time.split(':').map(Number);
            if (modifier === 'PM' && hours < 12) hours += 12;
            if (modifier === 'AM' && hours === 12) hours = 0;
            return { hours, minutes };
        };

        const startA = parseTime(a.StartTime);
        const startB = parseTime(b.StartTime);
        if (startA.hours !== startB.hours) {
            return startA.hours - startB.hours;
        }
        return startA.minutes - startB.minutes;
    };

    const [WorkingDays, SetWorkingDays] = useState([]);
    const handleCheckboxChange = (index: number, dayShort: string) => {
        const updatedWorkLocations = { ...workLocations };
        const newCheckedDays = [...checkedDays];
        newCheckedDays[index] = !newCheckedDays[index];
        setCheckedDays(newCheckedDays);
        const fullDayName = dayMapping[dayShort];
        for (const [key, value] of Object.entries(getSettingsData.data?.WorkingDays)) {
            if (key === fullDayName) {
                getSettingsData.data.WorkingDays[fullDayName] = !value;
                break;
            }
        }
        SetWorkingDays(getSettingsData.data?.WorkingDays)
        if (newCheckedDays[index]) {
            if (updatedWorkLocations.hasOwnProperty(fullDayName)) {
                if (workplaces[fullDayName] && workplaces[fullDayName].length > 0) {
                    updatedWorkLocations[fullDayName] = workplaces[fullDayName]; // Use data from workplaces
                } else {
                    // Otherwise, apply default data
                    if (is24HrFormat) {
                        updatedWorkLocations[fullDayName] = [{ StartTime: "", EndTime: "", Place: "" }];
                    } else {
                        updatedWorkLocations[fullDayName] = [{ StartTime: "", EndTime: "", Place: "" }];
                    }
                }
            }
        } else {
            if (updatedWorkLocations.hasOwnProperty(fullDayName)) {
                updatedWorkLocations[fullDayName] = updatedWorkLocations[fullDayName].filter(() => {
                    return false;
                });
            }
        }

        const Workplaces: any = {};

        Object.keys(updatedWorkLocations).forEach(day => {
            const entries = updatedWorkLocations[day];
            const hasTrueException = entries.some((entry: any) => entry.WorkplaceException);
            if (hasTrueException) {
                Workplaces[day] = entries.filter((entry: any) => entry.WorkplaceException).sort(compareTimes);
            } else {
                Workplaces[day] = entries.sort(compareTimes);
            }
        });
        initialWorkLocations = { ...Workplaces }
        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;
            }
        }

        setWorkLocations(Workplaces);

        getSettingsData.GetTeamsWorkplace.TeamMembers.forEach((member: any) => {
            Object.keys(member.DefaultWorkPlaces).forEach((day) => {
                const defaultSchedules = member.DefaultWorkPlaces[day];
                if (defaultSchedules && defaultSchedules.length > 0) {
                    const exceptions = member.WorkPlaceExceptions?.filter((exception: any) => {
                        return (
                            exception.Date === day &&
                            exception.Id === member.Id
                        );
                    }) || [];

                    if (exceptions.length > 0) {
                        // Replace default schedules with exceptions
                        member.DefaultWorkPlaces[day] = exceptions.map((exception: any) => ({
                            StartTime: moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('HH:mm'),
                            EndTime: moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('HH:mm'),
                            Place: exception.WorkingPlace,
                            WorkplaceException: true,
                            Id: exception.Id
                        }));
                    } else {
                        // Keep the default if no exceptions
                        member.DefaultWorkPlaces[day] = defaultSchedules.map((schedule: any) => ({
                            ...schedule,
                            WorkplaceException: false,
                        }));
                    }
                }
            });
        });


    };

    const updateWorkingDays = async (updatedWorkLocations: Record<string, WorkLocation[]>, day: any) => {

        const updatedWorkPlaces = Object.fromEntries(
            Object.entries(updatedWorkLocations as WorkLocations).map(([day, locations]) => [
                day,
                (locations as WorkLocation[]).map(({ Date, WorkplaceException, ...rest }) => rest) // Exclude Date and WorkplaceException
            ])
        );

        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;

            }
        }
        if (initialWorkLocations.hasOwnProperty(day)) {
            initialWorkLocations[day] = []; // Clear existing entries for the day
        }
        const worklocations: any = cleanWorkLocations(updatedWorkLocations)



        // Push new work locations for the specified day
        if (worklocations.hasOwnProperty(day)) {
            // Map over the worklocations for the specified day with explicit typing
            const newLocations = worklocations[day].map(({ WorkplaceException, ...rest }: WorkLocation) => ({
                ...rest,
                // Optional: Convert times to string format if needed
                StartTime: convertToTimeString(rest.StartTime),
                EndTime: convertToTimeString(rest.EndTime)
            }));

            // Update the initialWorkLocations with new data
            initialWorkLocations[day].push(...newLocations);
        }


        console.log(initialWorkLocations); // Check the updated state

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                FirstName: getSettingsData.data.FirstName,
                LastName: getSettingsData.data.LastName,
                TelNumber: getSettingsData.data.TelNumber.Value,
                UserImage: getSettingsData.data.UserImage.Value,
                DefaultLocation: getSettingsData.data.DefaultLocation,
                WorkingDays: getSettingsData.data.WorkingDays,
                DefaultWorkPlaces: initialWorkLocations,
                WorkPlaceVisibility: getSettingsData.data.WorkPlaceVisibility,
                DateFormat: getSettingsData.data.DateFormat,
                Is24hrFormat: getSettingsData.data.Is24HrFormat,
                FirstDayOfWeek: getSettingsData.data.FirstDayOfWeek,
                Departments: getSettingsData.data.Departments,
                Teams: getSettingsData.data.Teams,
                BookableLocations: getSettingsData.data.BookableLocations,
                ViewableLocations: getSettingsData.data.ViewableLocations,
                JobTitle: getSettingsData.data.JobTitle
            };

            const getDataResult = await GetSettingsService.SetSettings(data);
            if (getDataResult.data && getDataResult.data?.Updated) {

                CommonInfo.workingDays = getSettingsData.data.WorkingDays
                const workingdaysString = JSON.stringify(getSettingsData.data.WorkingDays);
                localStorage.setItem('Workingdays', workingdaysString);

            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
            ToastrService.error(t('AnErrorOccurredWhileSavingYourSettings'));

        }


    }

    function getDateWithOrginal(selectedDate: any, day: string, index: number) {
        if (!selectedDate) {

        }
        else {

            const selectedMoment = moment(selectedDate, 'YYYY-MM-DD').startOf('day');
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const storedValue = localStorage.getItem('Firstdayofweek');
            const firstDayOfWeek = storedValue === "null" ? 'Monday' : storedValue;
            const today = moment().startOf('day')
            const workingDaysString = localStorage.getItem('Workingdays');
            const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};
            const isWorkingDay = workingDays[day];
            if (!firstDayOfWeek) {
                throw new Error('First day of the week is not set in localStorage');
            }
            const normalizedFirstDayOfWeek = firstDayOfWeek.charAt(0).toUpperCase() + firstDayOfWeek.slice(1).toLowerCase();
            const firstDayIndex = daysOfWeek.indexOf(normalizedFirstDayOfWeek);
            if (firstDayIndex === -1) {
                throw new Error('Invalid first day of the week');
            }
            let startOfWeek;
            if (selectedMoment.isBefore(today, 'day') && currentweek) {
                startOfWeek = selectedMoment.clone().startOf('isoWeek').isoWeekday(firstDayIndex).startOf('day');

            }
            else {
                startOfWeek = selectedMoment.clone().startOf('isoWeek').isoWeekday(firstDayIndex).startOf('day');

            }

            if (selectedMoment.isAfter(startOfWeek, 'day')) {
                startOfWeek.add(1, 'week');
            }
            if (startOfWeek.isAfter(selectedMoment, 'day')) {
                startOfWeek.subtract(1, 'week');
            }
            if (!currentweek && !isWorkingDay) {
                while (startOfWeek.isBefore(selectedMoment, 'day')) {
                    startOfWeek.add(1, 'week');
                }
            }
            // Calculate the day index of the target day
            const dayIndex = daysOfWeek.indexOf(day);
            // Calculate the difference in days from the start of the week to the target day
            let dayDifference = dayIndex - firstDayIndex;
            if (dayDifference < 0) {
                dayDifference += 7;
            }
            // Calculate the target date
            const targetDate = startOfWeek.clone().add(dayDifference, 'days');
            const disableddates = disableCard(targetDate, day, index)
            const formattedDate = targetDate.format('Do');
            const newFormat = `${day} ${formattedDate}`
            const weekDates = [];
            for (let i = 0; i < 7; i++) {
                weekDates.push(selectedMoment.clone().add(i, 'days').format('YYYY-MM-DD'));
            }
            const isToday = targetDate.isSame(today, 'day');
            // setToday(isToday)
            return {
                disable: disableddates, date: newFormat, isToday: isToday, targetDate: targetDate, WeekDates: weekDates
            };

        }

    }

    function disableCard(selectedDate: any, day: string, index: number) {
        if (!selectedDate) {
            return false; // Handle case when selectedDate is not provided
        }

        const targetMoment = moment(selectedDate, 'YYYY-MM-DD').startOf('day').toDate();
        const currentDate = moment().startOf('day').toDate();

        // Return true if the targetDate is before or the same as the current date, meaning it should be disabled
        return targetMoment < currentDate;
    }



    const handleTimeChange = (day: string, index: number, type: 'StartTime' | 'EndTime', time: any) => {
        const today = moment();
        let startOfWeek = today.clone().startOf('week').day(day);
        console.log(startOfWeek, "startOfWeek");

        if (time.selectedTime !== null) {
            const formattedTime = formatDateToTimeString(time.selectedTime); // Use the formatting function
            const newTime = formattedTime;
            const existingStartTimes = workLocations[day].map(loc => loc.StartTime);
            const existingEndTimes = workLocations[day].map(loc => loc.EndTime);
            const selectedStartTime = is24HrFormat ? moment(existingStartTimes[index], 'HH:mm') : moment(existingStartTimes[index], 'hh:mm A');
            const selectedEndTime = is24HrFormat ? moment(existingEndTimes[index], 'HH:mm') : moment(existingEndTimes[index], 'hh:mm A');
            const newselectedTime = is24HrFormat ? moment(newTime, 'HH:mm') : moment(newTime, 'hh:mm A');

            const isStartDuplicate = existingStartTimes.some((startTime, i) => i !== index && startTime === formattedTime);
            const isEndDuplicate = existingEndTimes.some((endTime, i) => i !== index && endTime === formattedTime);

            if (type === 'StartTime' && isStartDuplicate) {
                ToastrService.warning(t('TheSameStartTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'EndTime' && isEndDuplicate) {
                ToastrService.warning(t('TheSameEndTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'StartTime' && selectedStartTime && selectedEndTime && newselectedTime.isAfter(selectedEndTime)) {
                ToastrService.warning(t('StartTimeMustBeEarlierThanTheEndTime'));
                return;
            }
            if (type === 'StartTime' && selectedEndTime && (newselectedTime.isSame(selectedEndTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && (newselectedTime.isSame(selectedStartTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && selectedEndTime && newselectedTime.isBefore(selectedStartTime)) {
                ToastrService.warning(t('EndTimeMustBeLaterThanTheStartTime'));
                return;
            }

            let updatedWorkLocations = [...workLocations[day]];

            if (type === 'StartTime') {
                updatedWorkLocations = updatedWorkLocations.map((loc, i) => {
                    if (i !== index) {
                        const existingStartTime = is24HrFormat ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                        const existingEndTime = is24HrFormat ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');
                        if (newselectedTime.isBetween(existingStartTime, existingEndTime, null, '[)')) {
                            return {
                                ...loc,
                                EndTime: newselectedTime.format(is24HrFormat ? 'HH:mm' : 'hh:mm A'), // Update format based on is24HrFormat
                            };
                        }
                    }
                    return loc;
                });
            }

            const newStartTime = type === 'StartTime' ? newselectedTime : selectedStartTime;
            const newEndTime = type === 'EndTime' ? newselectedTime : selectedEndTime;

            const isWithinRange = updatedWorkLocations.some((loc, i) => {
                if (i !== index) {
                    const existingStartTime = is24HrFormat ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                    const existingEndTime = is24HrFormat ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');

                    return (
                        newStartTime.isBetween(existingStartTime, existingEndTime, null, '[)') ||
                        newEndTime.isBetween(existingStartTime, existingEndTime, null, '(]') ||
                        (newStartTime.isBefore(existingStartTime) && newEndTime.isAfter(existingEndTime))
                    );
                }
                return false;
            });

            if (isWithinRange) {
                ToastrService.warning(t('TheSelectedTimeIsWithinexistingtimeRangeForTheSameDay'));
                return;
            }
            const currentWeekDates = Currentweek;
            let selectedDate: any | null = null;

            // Find the date corresponding to the given day
            currentWeekDates.forEach((date: string) => {
                if (moment(date).format('dddd') === day) {
                    selectedDate = moment(date).format('DD/MM/YYYY');
                }
            });

            if (!selectedDate) {
                console.error('No matching date found for the given day');
                return;
            }

            console.log(selectedDate, "dateForDay");
            setWorkLocations(prevLocations => {
                const updatedLocations = {
                    ...prevLocations,
                    [day]: prevLocations[day].map((loc, i) => (i === index ? { ...loc, [type]: formattedTime, Date: selectedDate } : loc))
                };

                let prevExceptions = [];
                const existingExceptions = workplaceexceptions || []

                const isDateInExceptions = existingExceptions.some(existingExc => existingExc.Date === selectedDate);

                if (!isDateInExceptions) {
                    prevExceptions = convertData(updatedLocations[day], selectedDate);
                }

                const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                    return !existingExceptions.some(existingExc => {
                        return prevExc.Date === existingExc.Date &&
                            prevExc.StartDateTime === existingExc.StartDateTime &&
                            prevExc.EndDateTime === existingExc.EndDateTime;
                    });
                });
                console.log("filteredExceptions", filteredExceptions);

                let updatedExceptions: WorkplaceException[] = [];

                if (filteredExceptions.length !== 0) {
                    filteredExceptions.forEach((exception: any) => {
                        if (exception.Id !== null) {
                            updatedExceptions.push({
                                ...exception,
                                Date: exception.Date,
                                StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: updatedLocations[day][index].Place,
                                Action: 'Edit',
                                Id: exception.Id
                            });
                        } else {
                            const newException: WorkplaceException = {
                                Date: selectedDate,
                                StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: updatedLocations[day][index].Place,
                                Id: null, // Set ID as null for new exception
                                Action: 'Add'
                            };

                            updatedExceptions = [...filteredExceptions, newException];
                        }
                    });
                } else {
                    existingExceptions.forEach((exception: any) => {
                        if (exception.Date === selectedDate && exception.StartDateTime === convertTimeString(prevLocations[day][index].StartTime, selectedDate) || exception.EndDateTime === convertTimeString(prevLocations[day][index].EndTime, selectedDate)) {
                            if (exception.Id !== null) {
                                updatedExceptions.push({
                                    ...exception,
                                    Date: exception.Date,
                                    StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                    EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                    WorkingPlace: updatedLocations[day][index].Place,
                                    Action: 'Edit',
                                    Id: exception.Id
                                });
                            } else {
                                const newException: WorkplaceException = {
                                    Date: selectedDate,
                                    StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                    EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                    WorkingPlace: updatedLocations[day][index].Place,
                                    Id: null, // Set ID as null for new exception
                                    Action: 'Add'
                                };

                                updatedExceptions = [...workplaceexceptions, newException];
                            }
                        }
                    });
                }

                setWorkplaceexceptions(updatedExceptions);
                console.log("updatedLocations", updatedLocations, "updatedExceptions", updatedExceptions);


                // Call updateWorkLocations with the new state
                updateWorkLocations(updatedLocations, day, updatedExceptions);
                return updatedLocations;
            });

        };
    }


    const updateLocations = (updatedWorkPlaces: any) => {
        const updatedWorkLocations = { ...updatedWorkPlaces };
        console.log(updatedWorkLocations, "worklocations");
        for (const day in updatedWorkLocations) {
            if (updatedWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = updatedWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                updatedWorkLocations[day] = updatedTimes;
            }
        }
        return updatedWorkLocations;

    };

    const cleanWorkLocations = (workLocations: any) => {
        const cleanedLocations: any = {};

        // Iterate over each day of the week
        Object.keys(workLocations).forEach(day => {
            // Filter out any entries with invalid StartTime or EndTime
            const validEntries = workLocations[day].filter((entry: any) => {
                return entry.StartTime !== "NaN:NaN" && entry.EndTime !== "NaN:NaN" && entry.Place;
            });

            // Only add the day if there are valid entries
            if (validEntries.length > 0) {
                cleanedLocations[day] = validEntries;
            }
        });

        return cleanedLocations;
    };


    const updateWorkLocations = async (updatedWorkLocations: any, day: any, newException: any) => {
        // Convert start and end times to strings
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;
            }
        }

        // Helper function to remove duplicates based on StartDateTime, EndDateTime, and Date
        const removeDuplicates = (exceptions: any) => {
            const uniqueItems = new Map();
            exceptions.forEach((exception: any) => {
                const key = `${exception.StartDateTime}-${exception.EndDateTime}-${exception.Date}`;
                if (!uniqueItems.has(key)) {
                    uniqueItems.set(key, exception);
                }
            });
            return Array.from(uniqueItems.values());
        };

        let workPlaceExceptions;
        if (newException.some((exception: any) => exception.Action === "Add")) {
            const uniqueExceptions = removeDuplicates(newException);
            workPlaceExceptions = uniqueExceptions.filter((exception: any) =>
                exception.Id === null || exception.Id === 0 &&
                exception.Action === "Add" &&
                !exception.EndDateTime.includes('NaN')
            );
        } else {
            workPlaceExceptions = (
                newException[0].Id !== null &&
                newException[0].Action &&
                !newException[0].EndDateTime.includes('NaN')
            ) ? [newException[0]] : [];
        }

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: initialWorkLocations,
                WorkPlaceExceptions: workPlaceExceptions
            };

            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlacesHaveBeenSaved'));
                GetWorklocations();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
        }
    };

    const getMySettingsUpdate = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                localStorage.setItem('Firstdayofweek', getDataResult.data.d.FirstDayOfWeek);
                getSettingsData.data = getDataResult.data.d
                GetWorklocations();

                getSettingsData.data.Departments = getDataResult.data.d.Departments;


            }
        } catch (error) {
        }
    };


    const GetWorklocations = async () => {
        // const dateRange = Currentweek;
        try {
            let data = {
                Id: userId,
                EmailAddress: userEmail,
                Date: moment(Currentweek[0]).format('DD/MM/YYYY'),
                StartDateTime: moment(Currentweek[0], 'YYYY-MM-DD ').format('DD/MM/YYYY HH:mm'),
                EndDateTime: moment(Currentweek[Currentweek.length - 1], 'YYYY-MM-DD   ').add(1, 'day').format('DD/MM/YYYY HH:mm'),
            }
            const getResult = await GetSettingsService.GetWorkLocation(data);
            if (getResult.data.d) {
                getSettingsData.GetWorkLocationdata = getResult.data.d;
                startDate = Currentweek[0];
                await GetMyTeamWorkPlace()

            }
        } catch (error) {

        }
    }
    const GetMyTeamWorkPlace = async () => {
        try {
            const data = {
                Id: id,
                DateStart: moment(Currentweek[0], 'YYYY-MM-DD ').format('DD/MM/YYYY'),
                DateEnd: moment(Currentweek[Currentweek.length - 1], 'YYYY-MM-DD ').add(1, 'day').format('DD/MM/YYYY')
            }
            const getResult = await GetSettingsService.GetTeamWorkPlaces(data)
            if (getResult.data.d) {
                getSettingsData.GetTeamsWorkplace = getResult.data.d;

                getArray('After');
            }
        }
        catch (error) {

        }
    }

    const formatDateToTimeString = (date: any) => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

        return is24HrFormat ? `${hours}:${formattedMinutes}` : timeString;
    };


    const handleDropdownChange = async (day: string, index: number, Place: any) => {


        const currentWeekDates = Currentweek;
        let selectedDate: any | null = null;

        // Find the date corresponding to the given day
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });

        if (!selectedDate) {
            console.error('No matching date found for the given day');
            return;
        }


        setWorkLocations(prevLocations => {
            const updatedLocations = {
                ...prevLocations,
                [day]: prevLocations[day].map((loc, i) => (i === index ? { ...loc, Place: Place, Date: selectedDate } : loc))
            };
            const existingExceptionIndex: any = (workplaceexceptions ?? []).filter((exc: WorkplaceException) => exc.Date === selectedDate);

            let prevExceptions = [];
            const existingExceptions = workplaceexceptions || [];
            const isDateInExceptions = existingExceptions.some(existingExc => existingExc.Date === selectedDate);

            if (!isDateInExceptions) {
                prevExceptions = convertData(updatedLocations[day], selectedDate);
            }

            const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                return !existingExceptions.some(existingExc => {
                    return prevExc.Date === existingExc.Date &&
                        prevExc.StartDateTime === existingExc.StartDateTime &&
                        prevExc.EndDateTime === existingExc.EndDateTime;
                });
            });
            console.log("filteredExceptions", filteredExceptions);

            let updatedExceptions: WorkplaceException[] = [];
            if (filteredExceptions.length != 0) {
                filteredExceptions.forEach((exception: any) => {
                    if (exception.Id !== 0) {
                        updatedExceptions.push({
                            ...exception,
                            Date: exception.Date,
                            StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                            EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                            WorkingPlace: Place,
                            Action: 'Edit',
                            Id: exception.Id
                        })

                    }
                    else {
                        const newException: WorkplaceException = {
                            Date: selectedDate,
                            StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                            EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                            WorkingPlace: Place,
                            Id: null, // Set ID as null for new exception
                            Action: 'Add'
                        };

                        updatedExceptions = [...filteredExceptions, newException];
                    }
                })
            }
            else {
                existingExceptionIndex.forEach((exception: any) => {
                    if (exception.Date === selectedDate && exception.StartDateTime === convertTimeString(prevLocations[day][index].StartTime, selectedDate) && exception.EndDateTime === convertTimeString(prevLocations[day][index].EndTime, selectedDate)) {

                        if (exception.Id !== 0) {
                            updatedExceptions.push({
                                ...exception,
                                Date: exception.Date,
                                StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: Place,
                                Action: 'Edit',
                                Id: exception.Id
                            })

                        }
                        else {
                            const newException: WorkplaceException = {
                                Date: selectedDate,
                                StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: Place,
                                Id: 0, // Set ID as null for new exception
                                Action: 'Add'
                            };

                            updatedExceptions = [...workplaceexceptions, newException];
                        }
                    }
                })
            }



            setWorkplaceexceptions(updatedExceptions);
            console.log("updatedLocations", updatedLocations, "updatedExceptions", updatedExceptions);

            updateWorkLocations(updatedLocations, day, updatedExceptions);
            return updatedLocations;
        });

    }


    function convertData(data: any, selectedDate: any) {
        return data.map((item: any) => {
            return {
                Date: selectedDate,
                StartDateTime: convertTimeString(item.StartTime, selectedDate),
                EndDateTime: convertTimeString(item.EndTime, selectedDate),
                WorkingPlace: item.Place,
                Id: 0, // Set Id to null for new exception
                Action: 'Add'
            };

        }).filter((entry: any) => entry !== null); // Remove any null values
    }

    const handleCardHover = (index: any) => {
        setHoveredCard(index);
    };

    const handleMouseLeave = () => {
        setHoveredCard(null);
    };

    const parseTime = (timeStr: any) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);

        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    };

    const handleAddWorkLocation = async (day: any, locations: any[], use24HourFormat: boolean, index: number) => {
        const latestEndTime = locations.reduce((latest, location) => {
            const { hours, minutes } = parseTime(location.EndTime ? location.EndTime : '9:00');
            const totalMinutes = hours * 60 + minutes;

            return totalMinutes > latest ? totalMinutes : latest;
        }, 0);

        const endHours = Math.floor(latestEndTime / 60);
        const endMinutes = Math.ceil((latestEndTime % 60) / 30) * 30; // Round up to the nearest 30 minutes

        let endHourString;
        let endMinuteString;
        let period = ''; // Empty string for 24-hour format

        if (use24HourFormat) {
            endHourString = endHours.toString().padStart(2, '0');
            endMinuteString = endMinutes.toString().padStart(2, '0');
        } else {
            // Determine AM/PM for the latest end time
            period = endHours >= 12 ? 'PM' : 'AM';
            endHourString = (endHours % 12 || 12).toString();
            endMinuteString = endMinutes.toString().padStart(2, '0');
        }

        const endTimeString = use24HourFormat
            ? `${endHourString}:${endMinuteString}`
            : `${endHourString}:${endMinuteString} ${period}`;

        // Use only one format for comparison to avoid ambiguity
        const endTime24HourString = `${endHours.toString().padStart(2, '0')}:${endMinuteString}`;
        const newStartTime = endTimeString;
        let newEndTime: any;
        if (endTime24HourString >= '17:30') {
            const nextEndHours = endHours + 1;
            newEndTime = use24HourFormat
                ? `${nextEndHours.toString().padStart(2, '0')}:${endMinuteString}`
                : `${(nextEndHours % 12 || 12).toString()}:${endMinuteString} ${nextEndHours >= 12 ? 'PM' : 'AM'}`;
        } else {
            newEndTime = use24HourFormat ? '17:30' : '5:30 PM';
        }
        const currentWeekDates = Currentweek;
        let selectedDate: any = null;
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });

        await setWorkLocations(prevLocations => {
            const updatedWorkLocation: any = {
                ...prevLocations,
                [day]: [...(prevLocations[day] || []), { StartTime: newStartTime, EndTime: newEndTime, Place: 'Office', WorkplaceException: true }]
            };
            const prevExceptions = convertData(updatedWorkLocation[day], selectedDate);
            // Filter out exceptions that are in both prevExceptions and getSettingsData.GetWorkLocationdata?.WorkPlaceExceptions
            const existingExceptions = getSettingsData.GetWorkLocationdata?.WorkPlaceExceptions || [];
            const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                return !existingExceptions.some((existingExc: any) => {
                    return prevExc.Date === existingExc.Date &&
                        prevExc.StartDateTime === existingExc.StartDateTime &&
                        prevExc.EndDateTime === existingExc.EndDateTime;
                });
            });

            const mergedExceptions = [
                ...existingExceptions,
                ...filteredExceptions
            ];
            if (existingExceptions.length !== 0) {
                setWorkplaceexceptions(mergedExceptions);


                updateWorkLocations(updatedWorkLocation, day, mergedExceptions);
                console.log("mergedExceptions", mergedExceptions);
            } else {
                setWorkplaceexceptions(prevExceptions);


                updateWorkLocations(updatedWorkLocation, day, prevExceptions);
                console.log("prevExceptions", prevExceptions);
            }

            // Set the filtered exceptions to state
            return updatedWorkLocation;
        });
        console.log("workLocations", workLocations);
    };



    const convertTimeString = (timeString: any, Selecteddate: any) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        // const Targetdate = moment(Selecteddate).format('DD/MM/YYYY')
        return `${Selecteddate} ${formattedHours}:${formattedMinutes}`;
    };

    const setDateFormat = () => {
        let newFormattype;
        switch (getSettingsData.data.DateFormat) {
            case ('dd/MM/yyyy'):
                return newFormattype = 'DD/MM/YYYY';
            case ('MM/DD/YYYY'):
                return newFormattype = 'MM/DD/YYYY';
            case ('MMMM, DD, YYYY'):
                return newFormattype = 'MMMM, DD, YYYY';
            case ('MMMM, dddd D, YYYY'):
                return newFormattype = 'MMMM, dddd D, YYYY';

            case ('dddd, D MMMM YYYY'):
                return newFormattype = 'dddd, D MMMM YYYY';
            case ('dddd Do MMMM YYYY'):
                return newFormattype = 'dddd Do MMMM YYYY';

            default:
                return newFormattype = 'DD/MM/YYYY';

        }
    }
    const dateFormat = setDateFormat();

    const theme = localStorage.getItem('Theme')
    const currentDayName = moment().format('dddd');
    const workingDaysString = localStorage.getItem('Workingdays');
    const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};
    const isWorkingDay = workingDays[currentDayName];

    const getActiveDate = () => {
        for (let i = 0; i < rearrangedWeekDays.length; i++) {
            const day = rearrangedWeekDays[i];
            const dateObj = getDateWithOrginal(selectedDate, day, i);
            if (dateObj && dateObj.isToday && workingDays[day]) {
                return moment(dateObj.date, 'dddd Do').format('YYYY-MM-DD');
            }
        }
        return moment(selectedDate).format('YYYY-MM-DD');
    };

    const activeDate = getActiveDate();
    const isTodayActive = rearrangedWeekDays.some((day, i) => getDateWithOrginal(selectedDate, day, i)?.isToday);

    const isDayDisabled = (date: any) => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(date).format('dddd');
        return workingDays[dayOfWeek] === false;
    };

    const deleteMessage1 = t('YouAboutToDeleteTheDataRelatedTo');
    const deleteMessage2 = t("ThisWillAlsoDeleteAllAssociatedDailyDataIncludingTheWorkplacePageAndSoForth")
    const deleteLabel = t("YesDeleteTheDataRelatedTo");

    const handleDeleteWorkLocation = async (day: any, startdateTime: any, EndDatetime: any, Workplace: any, Id: any) => {
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;
            }
        }

        const currentWeekDates = Currentweek;
        let selectedDate: any | null = null;

        // Find the date corresponding to the given day
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });
        const workPlaceExceptions = [{
            Date: selectedDate,
            StartDateTime: convertTimeString(startdateTime, selectedDate),
            EndDateTime: convertTimeString(EndDatetime, selectedDate),
            WorkingPlace: Workplace,
            Id: Id, // Set ID as null for new exception
            Action: 'Remove'
        }]
        console.log(workPlaceExceptions, "workPlaceExceptions");

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: initialWorkLocations,
                WorkPlaceExceptions: workPlaceExceptions
            };

            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlacesHaveBeenDeletedSucessfully'));
                GetWorklocations();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
        }
    }

    return (
        <div className={`sidenav-container`}>
            <Sidenav authToken={null} LoguserName={null} />
            <div className={theme === 'dark' ? ' content main-content_dark' : 'main-content content'} >
                <div className="row">
                    {/* <div className={`${theme === 'dark' ? 'position_sticky_dark row  px-4 pt-4 pb-2' : 'position_sticky row  px-4 pt-4 pb-2'}`}> */}
                    <div className="col-10 px-4">
                        <button onClick={goBack} className={theme === 'dark' ? 'bttn_dark' : 'bttn'} ><FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;{t('Back')}</button>
                        <label className='head'>/ {getSettingsData.GetTeamsWorkplace.TeamName}</label><span className='head'>  {department === 'undefined' ? '' : "/" + department}</span>
                    </div>
                    <div className="col-2 right px-4  ">
                        <Menu>
                            <MenuTrigger disableButtonEnhancement>
                                <Avatar
                                    name={localStorage.getItem('UserName')?.toString()}
                                    image={{
                                        src: getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                            ? getSettingsData.data.UserImage.Value
                                            : '',
                                    }}
                                    style={{
                                        cursor: "pointer", width: "45px", height: "43px"
                                    }}
                                    shape="circular"
                                />
                            </MenuTrigger>
                            <MenuPopover className='mt-2' style={{ width: "14rem" }}>
                                <MenuList>
                                    {/* <MenuItem style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={Commondata.folderName + "/resetpassword.svg"} />&nbsp;&nbsp;Reset password</MenuItem> */}
                                    <MenuItem onClick={logOut} style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Logoutlight.svg' : '/logout.svg'}`} />&nbsp;&nbsp;{t('LogOut')}</MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>
                        {ToastrService.getToastrComponent()}
                    </div>
                    {/* </div> */}

                    <div className="row px-3 time-top">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 centre_flex">
                            <img
                                id="icon"
                                className="pointer"
                                src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`}
                                onClick={handleIconClick}
                                alt="Calendar Icon"
                            />
                            {selectedDate && (
                                <span onClick={handleIconClick} className='px-2 date pointer'>{(moment(selectedDate).isSame(moment(), 'day') || moment(activeDate).isSame(moment(), 'day')) && (
                                    <span className={theme === 'dark' ? 'span_head' : ''}>{t('Today')}</span>)}  {moment(activeDate).format(dateFormat ? dateFormat : 'dddd Do MMMM YYYY')}</span>
                            )} &nbsp;
                            <span><Image onClick={() => setRightLeftDate('left')} className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/leftarrowlight.svg' : '/leftarrow.svg'}`}
                            />&nbsp;&nbsp;&nbsp;
                                <Image onClick={() => setRightLeftDate('right')} className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/rightarrowlight.svg' : '/rightarrow.svg'}`} />
                            </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {!isTodayActive && moment().format(dateFormat) !== moment(selectedDate).format(dateFormat) && isWorkingDay && <span className='col-xl-px-3 col-lg-px-3 col-md-px-3 col-sm-px-0'>
                                <button className={theme === 'dark' ? 'calendar_btn_dark' : 'calendar_btn'} onClick={setTodayDate}>
                                    <Image id="button_icon" style={{ width: "20px" }} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`} />
                                    &nbsp;&nbsp;{t('Today')}
                                </button></span>}

                            {/* {isCalendarVisible && ( */}
                            <div className="calendar-container">
                                <DatePicker value={selectedDatePicker ? dayjs(selectedDatePicker) : null} onChange={handleDateSelect} open={isCalendarVisible}
                                    disabledDate={isDayDisabled}
                                />
                            </div>
                            {/* )} */}
                        </div>
                        <div className={theme === 'dark' ? ' col-xl-6 col-lg-6 col-md-12 col-sm-12 dark_check right_position' : "col-xl-5 col-lg-5 col-md-12 col-sm-12 right_position"} >
                            <Checked checkedDays={checkedDays} onCheckboxChange={handleCheckboxChange} />
                        </div>
                    </div>
                    <div className="row workplace teams_workplace mt-3 p-1 px-4 row_height">
                        <div className="table-responsive">
                            <table className={theme === 'dark' ? 'table_dark' : ''}>
                                <thead>
                                    <tr>
                                        {checkedDays.includes(true) && <th></th>}
                                        {rearrangedWeekDays.map((weekday, index) => (
                                            workLocations[weekday].length > 0 && (
                                                <th className={`${getDateWithOrginal(selectedDate, weekday, index)?.isToday ? 'active_Date py-2 px-3 table_header' : 'py-2 px-3 table_header'}`} key={index}>
                                                    <p className={`m-0 ${getDateWithOrginal(selectedDate, weekday, index)?.disable ? 'disabled' : ''}`}>
                                                        {getDateWithOrginal(selectedDate, weekday, index)?.date}
                                                    </p>
                                                </th>
                                            )
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getSettingsData.GetTeamsWorkplace?.TeamMembers.length > 0 ? getSettingsData.GetTeamsWorkplace?.TeamMembers.map((member: any) => (
                                        <tr key={member.Id}>
                                            <td style={{ width: '13.5%', alignContent: 'center', paddingLeft: '10px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <Avatar
                                                        className='mt-1'
                                                        name={member.Name}
                                                        image={{
                                                            src: getSettingsData.GetTeamsWorkplace.TeamMembers.length > 0 && member.UserImage
                                                                ? member.UserImage
                                                                : "",
                                                        }}

                                                        style={{
                                                            cursor: 'pointer',
                                                            width: '32px',
                                                            height: '32px',
                                                        }}
                                                        shape='circular'
                                                    />
                                                    <div style={{ paddingLeft: '10px' }}>
                                                        <span className={theme === 'dark' ? 'teams_name_dark' : 'teams_name'}>{member.Name}</span><br />
                                                        <span className={theme === 'dark' ? 'teams_designation_dark' : 'teams_designation'}>{member.Role}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            {rearrangedWeekDays.map((day, i) => (
                                                workLocations[day].length > 0 && (
                                                    <td className={`mb-3 p-0 ${(getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId)) ? 'disabled' : ''}`} key={`${member.Id}_${day}`}>
                                                        <div >
                                                            {member.Id === userId && workLocations[day].map((location: any, index: number) => (
                                                                <div key={index} className='p-0 px-1'>
                                                                    {location.StartTime && location?.EndTime && <div className={`${theme === 'dark' ? 'Dark_timepicker row mt-1' : "row mt-1 card_time_picker "}`} style={{ alignItems: 'center' }}>
                                                                        <div className="col-4 px-1">
                                                                            <CustomTimePicker
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={location?.StartTime}
                                                                                onTimeChange={(event, data) => handleTimeChange(day, index, 'StartTime', data)}
                                                                                isFormattedTime={is24HrFormat}
                                                                            />
                                                                        </div>
                                                                        <div className="col-1 p-0" style={{ textAlign: 'center', color: theme === 'dark' ? "#ffF" : '#000' }}>
                                                                            -
                                                                        </div>
                                                                        <div className="col-4 p-0">
                                                                            <CustomTimePicker
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={location?.EndTime}
                                                                                onTimeChange={(event, data) => handleTimeChange(day, index, 'EndTime', data)}
                                                                                isFormattedTime={is24HrFormat}
                                                                            />
                                                                        </div>
                                                                        <div className="col-1 lg:px-4">
                                                                            {getSettingsData.GetWorkLocationdata.WorkPlaceExceptions !== null && !(getDateWithOrginal(selectedDate, day, i)?.disable) && location.WorkplaceException && <DeleteAction className={theme === 'dark' ? 'pointer delete_icon_dark' : 'pointer delete_icon '} deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={day + ' at ' + location.StartTime + '-' + location.EndTime}
                                                                                triggerdelete={() => handleDeleteWorkLocation(day, location.StartTime, location.EndTime, location.Place, location.Id)} />}
                                                                        </div>
                                                                    </div>}
                                                                    <div className='row'>
                                                                        <div className='col-12 card_worklocation'>
                                                                            {location?.Place && <CustomOptionsDropdown
                                                                                workplaceList={getSettingsData.workPlacelist}
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={location?.Place ? location?.Place : ''}
                                                                                onOptionSelect={(event, data) => handleDropdownChange(day, index, data.optionValue)}
                                                                                style={{ backgroundColor: theme === 'dark' ? (getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId)) ? "rgba(255, 255, 255, 0.1)" : "#124779" : (getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId)) ? "rgba(234, 239, 245, 1)" : "#C9E1F8", color: '#0000', textOverflow: 'ellipsis', fontWeight: 'bold' }}
                                                                            />}
                                                                            <div className='col-1'></div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                            {member.Id !== userId && member.DefaultWorkPlaces[day].map((workplace: any, index: number) => (
                                                                <div key={index} className='p-0 px-1'>
                                                                    <div className={`${theme === 'dark' ? 'Dark_timepicker row mt-1' : "row mt-1 card_time_picker "}`} style={{ alignItems: 'center' }}>
                                                                        <div className="col-5 p-0">
                                                                            <CustomTimePicker
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={workplace.StartTime}
                                                                                isFormattedTime={is24HrFormat}
                                                                            />
                                                                        </div>
                                                                        <div className="col-1 p-0" style={{ textAlign: 'center' }}>
                                                                            -
                                                                        </div>
                                                                        <div className="col-5 p-0">
                                                                            <CustomTimePicker
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={workplace.EndTime}
                                                                                isFormattedTime={is24HrFormat}
                                                                            />
                                                                        </div>
                                                                        <div className="col-1 p-0">
                                                                        </div>
                                                                    </div>
                                                                    <div className='row'>
                                                                        <div className='col-12 card_worklocation'>
                                                                            <CustomOptionsDropdown
                                                                                workplaceList={getSettingsData.workPlacelist}
                                                                                disabled={(getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId))}
                                                                                value={workplace.Place}
                                                                                style={{ backgroundColor: theme === 'dark' ? (getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId)) ? "rgba(255, 255, 255, 0.1)" : "#124779" : (getDateWithOrginal(selectedDate, day, index)?.disable || (member.Id !== userId)) ? "rgba(234, 239, 245, 1)" : "#C9E1F8", color: '#0000', textOverflow: 'ellipsis', fontWeight: 'bold' }}
                                                                            />
                                                                            <div className='col-1'></div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div style={{ textAlign: "center" }} className={theme === 'dark' ? 'menu_icon footers_dark' : 'menu_icon footers'}
                                                            onMouseEnter={() => getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? '' : handleCardHover(i)}
                                                            onMouseLeave={handleMouseLeave} >
                                                            <div className={`pointer dot_icon mt-4 ${getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? 'disabled' : ''}`} >
                                                                <svg width="20" height="18" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M11.1584 7.99996C11.1584 7.8563 11.2155 7.71852 11.317 7.61694C11.4186 7.51536 11.5564 7.45829 11.7001 7.45829C11.8437 7.45829 11.9815 7.51536 12.0831 7.61694C12.1847 7.71852 12.2417 7.8563 12.2417 7.99996C12.2417 8.14361 12.1847 8.28139 12.0831 8.38297C11.9815 8.48455 11.8437 8.54162 11.7001 8.54162C11.5564 8.54162 11.4186 8.48455 11.317 8.38297C11.2155 8.28139 11.1584 8.14361 11.1584 7.99996ZM8.11705 8.38297L7.74582 8.7542L8.11705 8.38297C8.01547 8.28139 7.9584 8.14361 7.9584 7.99996C7.9584 7.8563 8.01547 7.71852 8.11705 7.61694C8.21863 7.51536 8.35641 7.45829 8.50006 7.45829C8.64372 7.45829 8.7815 7.51536 8.88308 7.61694C8.98466 7.71852 9.04173 7.8563 9.04173 7.99996C9.04173 8.14361 8.98466 8.28139 8.88308 8.38297C8.7815 8.48455 8.64372 8.54162 8.50006 8.54162C8.35641 8.54162 8.21863 8.48455 8.11705 8.38297ZM5.68308 8.38297L6.05431 8.7542L5.68308 8.38297C5.5815 8.48455 5.44372 8.54162 5.30007 8.54162C5.15641 8.54162 5.01863 8.48455 4.91705 8.38297C4.81547 8.28139 4.7584 8.14361 4.7584 7.99996C4.7584 7.8563 4.81547 7.71852 4.91705 7.61694C5.01863 7.51536 5.15641 7.45829 5.30007 7.45829C5.44372 7.45829 5.5815 7.51536 5.68308 7.61694C5.78466 7.71852 5.84173 7.8563 5.84173 7.99996C5.84173 8.14361 5.78466 8.28139 5.68308 8.38297Z"
                                                                        fill={`${theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? 'rgba(255, 255, 255, 0.1)' : '#fff' : getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? '#a7a7a7' : 'black'}`} stroke={`${theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? 'rgba(255, 255, 255, 0.1)' : '#fff' : getDateWithOrginal(selectedDate, day, i)?.disable || (member.Id !== userId) ? '#a7a7a7' : 'black'}`} stroke-width="1.05" />
                                                                </svg>
                                                            </div>
                                                            <div className='add_btn'>
                                                                <button className={theme === 'dark' ? 'img_show_dark' : 'img_show'} disabled={member.Id !== userId} onClick={() => handleAddWorkLocation(day, workLocations[day], is24HrFormat, i)}> <Image id={theme === 'dark' ? 'add_img_dark' : "add_img"} className='pointer '
                                                                    src={`${CommonInfo.folderName}${theme === 'dark' ? '/plus_circlelight.svg' : '/plus-circle.svg'}`} />&nbsp;&nbsp;Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                )
                                            ))}
                                        </tr>
                                    )) : []}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamWorkPlaces;